export default function CookiePolicy() {
  return (
    <div className="text-bg-dark text-white _pt-5 _pb-5 mb-3 mt-3 information">
      <div className="m-auto">
        <div>
          <div className="d-flex align-items-center gap-3">
            <h1>Cookie Policy</h1>
            <span>18+</span>
          </div>
          <span>Last Updated: April 10, 2024</span>
        </div>

        <p>
          This Cookie Policy ("Policy") applies to websites operated by Natural
          Intelligence Ltd. ("NI", "us", or "we"). By using the Site, you agree
          to the use of cookies as described in this Policy.
        </p>
        <p>
          We reserve the right to modify this Policy at any time. If there are
          significant changes, you will be notified via the Site. We encourage
          you to review this page periodically. Continued use of the Site
          constitutes your acceptance of any changes. If you do not agree with
          the terms, discontinue use of the Site or adjust your browser settings
          to refuse cookies.
        </p>
        <div>
          <span>
            This Cookie Policy is part of our Privacy Policy, and terms defined
            there have the same meanings here. This Policy explains:
          </span>
          <ul>
            <li>What cookies are?</li>
            <li>Cookies used when you use the Site</li>
            <li>Third-party use of cookies on the Site.</li>
            <li>Your cookie options</li>
            <li>Interest-Based Advertising</li>
          </ul>
        </div>

        <div>
          <ol>
            <li>
              <div>What Are Cookies?</div>
              <p>
                A cookie is a small text file stored in your web browser that
                allows the Site or a third party to recognize you. Cookies may
                be used for:
              </p>
              <ol>
                <li>Enabling certain functions</li>
                <li>Providing analytics</li>
                <li>Storing preferences</li>
                <li>Enabling ad delivery and behavioral advertising</li>
              </ol>
              <p>
                Cookies can be session cookies (expire when you close your
                browser) or persistent cookies (remain until they expire or you
                delete them). Cookies placed by the site you’re visiting are
                "first-party cookies," while those placed by other entities are
                "third-party cookies."
              </p>
              <p>
                Cookies often work with pixel tags (web beacons or clear GIFs)
                to measure visitor actions. For example, pixel tags may track
                interactions on the Site or referrals to partners, for
                retargeting or interest-based advertising as explained in
                section 5 below.
              </p>
            </li>
            <li>
              <div>What Cookies Are Used When I Use the Site?</div>
              <p>
                When you access or use the Site, we or a third party may place
                several cookies in your browser. Some cookies are used only if
                you use certain features or preferences, while others serve
                longer-term purposes, as detailed in our Privacy Policy.
              </p>
              <p>Each cookie serves one of the following purposes:</p>
              <ul>
                <li>
                  Essential Cookies: These first-party cookies allow users to
                  use features of the Site like staying logged in or making
                  purchases
                </li>
                <li>
                  Preference Cookies: These first-party cookies store your Site
                  preferences
                </li>
                <li>
                  Ad Targeting Cookies: These third-party cookies enable
                  advertising networks to deliver ads relevant to your
                  activities.
                </li>
              </ul>
            </li>
            <li>
              <div>How Do Third Parties Use Cookies on the Site?</div>
              <p>
                Third parties like analytics vendors or ad networks use cookies
                to collect user information anonymously. This helps them
                understand users' activities on the Site and other websites they
                visit.
              </p>
            </li>
            <li>
              <div>What Are My Cookie Options?</div>
              <p>
                You can change your browser settings to delete cookies or refuse
                new ones. Visit your browser’s help pages for instructions. Note
                that if you delete or refuse cookies, some features of the Site
                may not function properly.
              </p>
              <p>
                You may also opt-out of third-party cookies by following
                instructions in each third party's privacy policy.
              </p>
            </li>
            <li>
              <div>How to Manage Cookies?</div>
              <p>
                Cookies help you get the most out of our Site. If you disable
                cookies, certain sections of the Site may not function properly.
              </p>
            </li>
            <li>
              <div>How to Manage Your Cookies?</div>
              <p>
                Most browsers are set to accept cookies by default. You can
                change settings to block cookies or alert you when cookies are
                sent.
              </p>
              <p>
                Be aware that disabling cookies may affect your experience on
                the Site, such as not being able to visit certain areas or
                receive personalized content.
              </p>
              <p>
                For more information about the cookies used on the Site, click
                here.
              </p>
            </li>
            <li>
              <div>Interest-Based Advertising</div>
              <p>
                We and third parties engage in interest-based advertising to
                deliver personalized content that we believe will be of interest
                to you. We do not control third-party cookies or the resulting
                information for online, mobile, or email advertising and are not
                responsible for their actions or policies. Your Online Choices |
                EDAA{" "}
                <a href="https://www.youronlinechoices.eu">
                  https://www.youronlinechoices.eu
                </a>
              </p>
            </li>
          </ol>
        </div>
        <h2># How to Disable Behaviorally Targeted Advertising Cookies</h2>
        <p>
          For users in the European Union, visit www.youronlinechoices.eu. For
          users in the US, visit www.aboutads.info/choices.
        </p>
        <h2>How to Enable and Disable Cookies Using Your Browser</h2>
        <p>Google Chrome:</p>
        <ol>
          <li>Click the wrench icon on the toolbar</li>
          <li>Select Settings - Show advanced settings.</li>
          <li>In the "Privacy" section, click 'Content settings.'</li>
          <li>
            To enable cookies, pick 'Allow local data to be set.' To allow only
            first-party cookies, pick 'Block all third-party cookies without
            exception.'
          </li>
          <li>To disable cookies, pick 'Block sites from setting any data.'</li>
        </ol>
        <p>For more information, visit Google’s support page.</p>

        <h3>Microsoft Internet Explorer:</h3>
        <ol>
          <li>
            Click 'Tools' at the top of your browser window and select 'Internet
            Options.'
          </li>
          <li>Navigate to the 'Privacy' tab.</li>
          <li>To enable cookies, set the slider to 'Medium' or below.</li>
          <li>To disable cookies, move the slider to the top.</li>
        </ol>
        <p>For more information, visit Microsoft’s support page.</p>

        <h3>Microsoft Edge:</h3>
        <ol>
          <li>
            Click the More actions button on the toolbar, and select Settings.
          </li>
          <li>Search for View advanced settings and click it.</li>
          <li>
            Under Cookies section, select either 'Don't block cookies' (default)
            or 'Block only third-party cookies.'
          </li>
        </ol>
        <h3>Mozilla Firefox:</h3>
        <ol>
          <li>Click 'Tools' at the browser menu and select 'Options.'</li>
          <li>Select the Privacy panel.</li>
          <li>To enable cookies, check 'Accept cookies for sites.'</li>
          <li>To disable cookies, uncheck 'Accept cookies for sites.'</li>
        </ol>
        <p>For more information, visit Mozilla’s support page.</p>
        <h3>Opera:</h3>
        <ol>
          <li>Click 'Setting' at the browser menu and select 'Settings.'</li>
          <li>Select 'Quick Preferences.'</li>
          <li>To enable cookies, check 'Enable Cookies.'</li>
          <li>To disable cookies, uncheck 'Enable Cookies.'</li>
        </ol>
        <p>For more information, visit Opera’s support page.</p>
        <h3>Safari on OSX:</h3>
        <ol>
          <li>Click 'Safari' at the menu bar and select 'Preferences.'</li>
          <li>Click 'Security.'</li>
          <li>To enable cookies, select 'Only from site you navigate to.'</li>
          <li>To disable cookies, select 'Never.'</li>
        </ol>
        <p>For more information, visit Apple’s support page.</p>
      </div>
    </div>
  );
}
